
























































































helpers = require('../../helpers.coffee')
view_model = {
  mixins: [require('../../mixins/users_options.coffee')]
  components:
    filters: require('./filters.vue')
    calendar: require('./calendar')
    liveFeed: require('./live_feed')
    taskModalForm: require('./modal_form')
    doneTasks: require('./done_tasks')
    taskList: require('./list')
    taskItem: require('./list_item')
    pausedContacts: require('./paused_contacts')
    statisticCards: require('./statistic_cards')
    doneTasksFeed: require('./done_tasks/done_tasks_feed')
    ozzyTasks: require('./ozzy_tasks/ozzy_tasks_wrapper')
    meetingModal: require('../shared/modals/meeting_modal')
  data: ->
    users_options: [{ value: null, text: 'Carregando...'}]
    filters: {}
    today_filter: {}
    overdue_filter: {}
    future_filter: {}
    number_of_overdue_tasks: '0'
    number_of_future_tasks: '0'
    number_of_today_tasks: '0'
    selected_task: new Task
    current_user: Session.current_user
    contact: {}
    show_meeting_modal: false
  methods:
    emitOpenCompose: ->
      event.originalEventName = 'Compose::Open'
      EventsBus.$emit 'Compose::Open', { event }
    toggleTaskBar: (data) ->
      EventsBus.$emit 'toggle-task-bar', {contact_id: data.contact.id, task: data.task, open_comment: data.open_comment}
    numberOfFutureTasks: (value) ->
      @number_of_future_tasks = value
    numberOfOverdueTasks: (value) ->
      @number_of_overdue_tasks = value
    numberOfTodayTasks: (value) ->
      @number_of_today_tasks = value
    openTaskModalForm: ->
      EventsBus.$emit 'TaskModalForm::Show', { task_id: null, contact: null, id: 'manual-task-form-modal' }
    openModalForm: (data) ->
      EventsBus.$emit 'TaskModalForm::Show', { task_id: data.task.id, contact: null, id: 'manual-task-form-modal' }
    openMeetingModal: (data) ->
      @selected_task = data.task
      @show_meeting_modal = true
    closeMeetingModal: ->
      @selected_task = new Task
      @show_meeting_modal = false
    removeTask: (data) ->
      task = data.task
      @$refs.today_tasks.removeTask(task)
      @$refs.overdue_tasks.removeTask(task)
      if task.due_on.isBefore(moment().endOf('day')) && task.due_on.isAfter(moment().startOf('day'))
        @$refs.statistic_cards.decreaseTodayTasks(task)
    taskCreated: (data) ->
      metadata = { 'Tipo de tarefa': data.task.text }
      IntercomCtrl.trackEvent('Tarefa criada a partir da área de tarefas', metadata)
      if data.task.due_on.isBefore(moment().endOf('day')) || data.task.undefined_time
        if data.task.due_on.isAfter(moment().startOf('day'))
          @$refs.today_tasks.addTask(data.task)
          @$refs.statistic_cards.increaseTodayTasks(data.task)
        else
          @$refs.overdue_tasks.addTask(data.task)
    reloadTasks: ->
      @$nextTick =>
        @$refs.today_tasks.reloadTasks()
        @$refs.overdue_tasks.reloadTasks()
        @$refs.future_tasks.reloadTasks()
    moment: -> moment()
    filter: (filters)->
      @filters = filters
      @setTodayFilter()
      @setOverdueFilter()
      @setFutureFilter()
      @reloadTasks()
    primaryFilter: ->
      primary =
        s: ['due_on asc', 'id desc']
        done_at_null: true
        assigned_to_id_eq: @filters.user_id_eq
      return primary unless Session.current_user.isSeller()
      Object.assign(primary, { assigned_to_id_eq: Session.current_user.id })
    setTodayFilter: ->
      interval = { due_on_gteq: @start_of_day, due_on_lteq: @end_of_day }
      @today_filter = Object.assign(@primaryFilter(), @filters, interval)
    setOverdueFilter: ->
      interval = { due_on_lt: @start_of_day }
      @overdue_filter = Object.assign(@primaryFilter(), @filters, interval)
    setFutureFilter: ->
      interval = { due_on_gt: @end_of_day }
      @future_filter = Object.assign(@primaryFilter(), @filters, interval)
    setFiltersFromQueryParamsLocal: ->
      @filters = @$router.currentRoute.query
      @filters.service_eq = "ManualTasksServices::#{@filters.service_eq}" if @filters.service_eq
      @filters.user_id_eq = null if Session.current_user.isSeller()
      @filters
  created: ->
    @tasks_resources = new TasksResource
    @end_of_day = moment().endOf('day').toJSON().replace('Z', '') + '999Z'
    @start_of_day = moment().startOf('day').toJSON()
    @setFiltersFromQueryParamsLocal()
    @setTodayFilter()
    @setOverdueFilter()
    @setFutureFilter()
    EventsBus.$on 'Task::Edit', @openModalForm
    EventsBus.$on 'Task::Created', @taskCreated
    EventsBus.$on 'meeting-modal-show', @openMeetingModal
    @$store.dispatch('fetchMeetingTypes') if @$store.getters.meetingTypesCount == 0
    @$store.dispatch('fetchLostReasons') if @$store.getters.lostReasonsCount == 0
  beforeDestroy: ->
    EventsBus.$off 'Task::Edit', @openModalForm
    EventsBus.$off 'Task::Created', @taskCreated
    EventsBus.$off 'meeting-modal-show', @openMeetingModal
}
exports.default = helpers.vue_include(view_model, helpers.manual_tasks.list_wrapper, helpers.form, helpers.filters)



// WEBPACK FOOTER //
// ./~/vue-loader/lib/selector.js?type=script&index=0!./src/views/manual_tasks/index.vue